export const headersReserveStock = {
  DocNum: {
    name: "Order Number",
    width: 1.3,
    isSort: true,
    textAlign: "left",
    sortDirection: "asc",
  },
  CardCode: {
    name: "Customer Code",
    width: 1.4,
    textAlign: "left",
  },
  CardName: {
    name: "Customer Name",
    width: 2.2,
    textAlign: "left",
  },
  Address2: {
    name: "Address",
    width: 2.2,
    textAlign: "left",
  },
  WhsName: {
    name: "Warehouse",
    width: 1.2,
    textAlign: "left",
  },
  ItemCode: {
    name: "Item Code",
    width: 1.4,
    textAlign: "left",
  },
  Dscription: {
    name: "Description",
    width: 2.4,
    textAlign: "left",
  },
  "Open Qty PCS": {
    name: "Order Reserved",
    width: 1,
    textAlign: "left",
  },
  SlpName: {
    name: "Sales",
    width: 1.4,
    textAlign: "left",
  },
  "Order Date": {
    name: "Order Date",
    width: 1.3,
    textAlign: "left",
  },
  "Valid until": {
    name: "Valid until",
    width: 1.3,
    textAlign: "left",
  },
  "Doc Status": {
    name: "Doc Status",
    width: 1.2,
    textAlign: "left",
  },
  "": { name: "", width: 0.2, textAlign: "" },
};

export const mediumDeviceHeadersReserveStock = {
  DocNum: {
    name: "Order Number",
    width: 1.2,
    isSort: true,
    textAlign: "left",
    sortDirection: "asc",
  },
  CardCode: {
    name: "Customer Code",
    width: 1.4,
    textAlign: "left",
  },
  CardName: {
    name: "Customer Name",
    width: 2,
    textAlign: "left",
  },
  Address2: {
    name: "Address",
    width: 2,
    textAlign: "left",
  },
  WhsName: {
    name: "Warehouse",
    width: 1.2,
    textAlign: "left",
  },
  ItemCode: {
    name: "Item Code",
    width: 1.4,
    textAlign: "left",
  },
  Dscription: {
    name: "Description",
    width: 2.2,
    textAlign: "left",
  },
  "Open Qty PCS": {
    name: "Order Reserved",
    width: 1.1,
    textAlign: "left",
  },
  SlpName: {
    name: "Sales",
    width: 1.4,
    textAlign: "left",
  },
  "Order Date": {
    name: "Order Date",
    width: 1.3,
    textAlign: "left",
  },
  "Valid until": {
    name: "Valid until",
    width: 1.3,
    textAlign: "left",
  },
  "Doc Status": {
    name: "Doc Status",
    width: 1.2,
    textAlign: "left",
  },
  "": { name: "", width: 0.2, textAlign: "" },
};

export const smallDeviceHeadersReserveStock = {
  DocNum: {
    name: "Order Number",
    width: 1.2,
    isSort: true,
    textAlign: "left",
    sortDirection: "asc",
  },
  CardCode: {
    name: "Customer Code",
    width: 1.4,
    textAlign: "left",
  },
  CardName: {
    name: "Customer Name",
    width: 1.8,
    textAlign: "left",
  },
  Address2: {
    name: "Address",
    width: 1.8,
    textAlign: "left",
  },
  WhsName: {
    name: "Warehouse",
    width: 1.1,
    textAlign: "left",
  },
  ItemCode: {
    name: "Item Code",
    width: 1.4,
    textAlign: "left",
  },
  Dscription: {
    name: "Description",
    width: 2,
    textAlign: "left",
  },
  "Open Qty PCS": {
    name: "Order Reserved",
    width: 1,
    textAlign: "left",
  },
  SlpName: {
    name: "Sales",
    width: 1.3,
    textAlign: "left",
  },
  "Order Date": {
    name: "Order Date",
    width: 1.3,
    textAlign: "left",
  },
  "Valid until": {
    name: "Valid until",
    width: 1.3,
    textAlign: "left",
  },
  "Doc Status": {
    name: "Doc Status",
    width: 1.2,
    textAlign: "left",
  },
  "": { name: "", width: 0.1, textAlign: "" },
};

export const inlineOrderReservedHeaders = {
  DocNum: {
    name: "Order Number",
    width: 1.2,
    textAlign: "left",
  },
  CardName: {
    name: "Customer Name",
    width: 2.1,
    textAlign: "left",
  },
  Address2: {
    name: "Address",
    width: 2.2,
    textAlign: "left",
  },
  "Open Qty PCS": {
    name: "Open Qty",
    width: 1,
    textAlign: "left",
  },
  SlpName: {
    name: "Sales",
    width: 1.3,
    textAlign: "left",
  },
  "Order Date": {
    name: "Order Date",
    width: 1.2,
    textAlign: "left",
  },
  "Valid until": {
    name: "Valid until",
    width: 1.2,
    textAlign: "left",
  },
  "Doc Status": {
    name: "Doc Status",
    width: 1.1,
    textAlign: "left",
  },
};